import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import styled from "react-emotion";

const StyledDatePicker = styled("div")`
  & .react-datepicker__close-icon {
    display: block;
  }
  & .react-datepicker__close-icon::after {
    background-color: grey;
  }
  & .react-datepicker__input-container input[type="text"] {
    width: ${({ isClearable }) => (isClearable ? "6.5em" : "5.5em")};
  }
`;

export default class DatePicker extends Component {
  static propTypes = {
    className: PropTypes.string,
    isClearable: PropTypes.bool,
    dateFormat: PropTypes.string,
    disabled: PropTypes.bool,
    disableWeekends: PropTypes.bool,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    selectsStart: PropTypes.bool,
    selectsEnd: PropTypes.bool,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    openToDate: PropTypes.instanceOf(Date),
    selected: PropTypes.instanceOf(Date),
    filterDate: PropTypes.func, // Passed JS Date returns bool.
    onChange: PropTypes.func, // Passed JS Date as argument.
    locale: PropTypes.string,
    disabledKeyboardNavigation: PropTypes.bool,
    placeholderText: PropTypes.string
  };

  static defaultProps = {
    isClearable: false,
    dateFormat: "DD/MM/YYYY", // default to UK format
    locale: "en-gb",
    disabledKeyboardNavigation: true
  };

  isWeekDay = date => {
    const day = date.day();
    return day !== 0 && day !== 6;
  };

  onChange = moment => {
    if (this.props.onChange) {
      this.props.onChange(moment ? moment.toDate() : moment); //Converts moment back into JS Date object.
    }
  };

  filterDate = moment => {
    let validDate = true;
    if (this.props.filterDate) {
      validDate = this.props.filterDate(moment.toDate());
    }
    if (validDate && this.props.disableWeekends) {
      validDate = this.isWeekDay(moment);
    }
    return validDate;
  };

  render = () => {
    let classNames = ["upn-component-date-picker"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    return (
      <StyledDatePicker
        className={classNames.join(" ")}
        isClearable={this.props.isClearable}
      >
        <ReactDatePicker
          isClearable={this.props.isClearable}
          dateFormat={this.props.dateFormat}
          // JS Date objects converted into moment objects
          disabled={this.props.disabled}
          startDate={
            this.props.startDate ? moment(this.props.startDate) : undefined
          }
          endDate={this.props.endDate ? moment(this.props.endDate) : undefined}
          maxDate={this.props.maxDate ? moment(this.props.maxDate) : undefined}
          minDate={this.props.minDate ? moment(this.props.minDate) : undefined}
          openToDate={
            this.props.openToDate ? moment(this.props.openToDate) : undefined
          }
          selected={
            this.props.selected ? moment(this.props.selected) : undefined
          }
          selectsStart={this.props.selectsStart}
          selectsEnd={this.props.selectsEnd}
          filterDate={this.filterDate}
          onChange={this.onChange}
          locale={this.props.locale}
          disabledKeyboardNavigation={this.props.disabledKeyboardNavigation}
          placeholderText={this.props.placeholderText}
        />
      </StyledDatePicker>
    );
  };
}
